export default size => {
  // Generate a random n-byte array
  let bytes = new Uint8Array(size)
  for (let i = 0; i < size; i++) {
    bytes[i] = Math.floor(Math.random() * 256)
  }
  // Convert the array to a hex string
  const hexString = Array.from(bytes)
  .map(b => b.toString(16).padStart(2, '0'))
  .join('')
  return hexString
}
